//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postCustomLogin,
} from "../../../helpers/fakebackend_helper";
import * as url from "../../../helpers/url_helper";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';
import config from '../../../config';

export const loginUser = (user, navigate) => async (dispatch) => {
  try {
    const loginPayload = {
      data: [{
        email: user.email,
        password: user.password,
        appName: config.appName
      }]
    };

    console.log('Sending login payload:', loginPayload);

    const response = await fetch(`${config.api.API_URL}python/login/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(loginPayload)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Login failed');
    }

    const data = await response.json();
    console.log('Login response:', data);

    if (data.error !== 0 || !data.result || !data.result[0]) {
      throw new Error(data.message || 'Invalid login response');
    }
    
    // Store all response data
    const loginResponse = data.result[0];  // Use the entire result object

    // Save auth data to session storage
    sessionStorage.setItem("authUser", JSON.stringify(loginResponse));

    // Call session data API
    const getBrowserInfo = () => {
      try {
        const userAgent = navigator.userAgent || '';
        const browserInfo = {
          make: 'Unknown',
          version: 'Unknown',
          os: 'Unknown'
        };

        // Detect browser - Safe version extraction
        const getVersionSafely = (pattern) => {
          try {
            // Use global helper if available
            if (window.safeMatchUserAgent && typeof window.safeMatchUserAgent === 'function') {
              return window.safeMatchUserAgent(pattern);
            }
            
            // Fallback to direct implementation
            const match = userAgent.match(pattern);
            return match && match[1] ? match[1] : 'Unknown';
          } catch (error) {
            console.error('Error extracting browser version:', error);
            return 'Unknown';
          }
        };

        // Special Safari detection that avoids the issue
        const isSafari = () => {
          return /Safari/i.test(userAgent) && !/Chrome/i.test(userAgent);
        };
        
        const getSafariVersion = () => {
          try {
            if (isSafari()) {
              const match = userAgent.match(/Version\/([0-9.]+)/);
              return match && match[1] ? match[1] : 'Unknown';
            }
            return 'Unknown';
          } catch (e) {
            return 'Unknown';
          }
        };

        // Mobile detection first - higher priority
        if (/Android/i.test(userAgent)) {
          browserInfo.os = 'Android';
          if (/Chrome/i.test(userAgent)) {
            browserInfo.make = 'Chrome Mobile';
            browserInfo.version = getVersionSafely(/Chrome\/([0-9.]+)/);
          } else {
            browserInfo.make = 'Android Browser';
            browserInfo.version = 'Mobile';
          }
        } 
        else if (/iPhone|iPad|iPod/i.test(userAgent)) {
          browserInfo.os = 'iOS';
          if (/Safari/i.test(userAgent)) {
            browserInfo.make = 'Safari Mobile';
            browserInfo.version = getSafariVersion() || 'Mobile';
          } else {
            browserInfo.make = 'iOS Browser';
            browserInfo.version = 'Mobile';
          }
        }
        // Desktop browsers
        else if (/Chrome/i.test(userAgent)) {
          browserInfo.make = 'Chrome';
          browserInfo.version = getVersionSafely(/Chrome\/([0-9.]+)/);
        } 
        else if (/Firefox/i.test(userAgent)) {
          browserInfo.make = 'Firefox';
          browserInfo.version = getVersionSafely(/Firefox\/([0-9.]+)/);
        } 
        else if (/Safari/i.test(userAgent)) {
          browserInfo.make = 'Safari';
          browserInfo.version = getSafariVersion();
        } 
        else if (/Edge|Edg/i.test(userAgent)) {
          browserInfo.make = 'Edge';
          browserInfo.version = getVersionSafely(/Edge\/([0-9.]+)/) || getVersionSafely(/Edg\/([0-9.]+)/);
        }

        // Detect OS if not already set
        if (browserInfo.os === 'Unknown') {
          if (/Windows/i.test(userAgent)) {
            browserInfo.os = `Windows ${/Windows NT 10.0/i.test(userAgent) ? '10' : 
                                      /Windows NT 6.3/i.test(userAgent) ? '8.1' : 
                                      /Windows NT 6.2/i.test(userAgent) ? '8' : 
                                      /Windows NT 6.1/i.test(userAgent) ? '7' : ''}`;
          } else if (/Mac/i.test(userAgent)) {
            browserInfo.os = 'MacOS';
          } else if (/Linux/i.test(userAgent)) {
            browserInfo.os = 'Linux';
          }
        }

        return browserInfo;
      } catch (error) {
        console.error('Error getting browser info:', error);
        return {
          make: 'Unknown',
          version: 'Unknown',
          os: 'Unknown'
        };
      }
    };

    const browserInfo = getBrowserInfo();
    const deviceId = `web_${Math.random().toString(36).substr(2, 9)}`; // Generate a unique device ID

    const sessionPayload = {
      emailId: user.email,
      sessionStart: Date.now(),
      action: "login",
      usertype: "admin",
      device: "browser",
      deviceId: deviceId,
      make: browserInfo.make,
      OSVersion: browserInfo.os,
      appVersion: browserInfo.version,
      deviceModel: `${browserInfo.make} ${browserInfo.version}`
    };

    console.log('Sending session payload:', sessionPayload);

    const sessionResponse = await fetch(`${config.api.API_URL}python/adminUserAddSessionData/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': loginResponse.token
      },
      body: JSON.stringify(sessionPayload)
    });

    if (sessionResponse.ok) {
      const sessionData = await sessionResponse.json();
      console.log('Session data response:', sessionData);
      
      // Extract sessionLogId from the correct path in response
      const sessionLogId = sessionData.result?.sessionLogId;
      
      if (!sessionLogId) {
        console.error('No sessionLogId found in response:', sessionData);
      }
      
      // Store session data in sessionStorage for logout
      sessionStorage.setItem("sessionData", JSON.stringify({
        sessionLogId: sessionLogId,
        deviceId: deviceId,
        loginTime: Date.now(),
        appName: config.appName,
        email: user.email  // Store email for logout
      }));
    }

    // Get cognito token
    const cognitoResponse = await fetch(`${config.api.API_URL}cognitoToken`, {
      headers: {
        'Authorization': loginResponse.token
      }
    });

    if (cognitoResponse.ok) {
      const cognitoData = await cognitoResponse.json();
      // Store cognito token
      sessionStorage.setItem("cognitoToken", cognitoData.token);
    } else {
      const cognitoError = await cognitoResponse.json();
      console.error('Cognito token fetch failed:', cognitoError);
    }

    dispatch(loginSuccess(loginResponse));
    
    // Use direct window location for navigation to bypass potential redirects
    window.location.href = "/dashboard";
    
    // Original navigation as fallback
    // navigate("/dashboard");
  } catch (error) {
    console.error('Login error:', error);
    dispatch(apiError(error.message));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const sessionData = JSON.parse(sessionStorage.getItem("sessionData"));

    console.log('Stored session data:', sessionData);
    console.log('Stored auth data:', authUser);

    if (!authUser?.token) {
      throw new Error('No auth token found');
    }

    // First API call - Update session data
    const sessionUpdatePayload = {
      createdAt: Date.now(),
      action: "logout",
      sessionLogId: sessionData?.sessionLogId
    };

    console.log('Sending session update payload:', sessionUpdatePayload);

    const sessionResponse = await fetch(`${config.api.API_URL}python/adminUserAddSessionData/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authUser.token
      },
      body: JSON.stringify(sessionUpdatePayload)
    });

    if (!sessionResponse.ok) {
      const sessionError = await sessionResponse.json();
      console.error('Session update failed:', sessionError);
      // Continue with logout even if session update fails
    }

    // Wait for first API call to complete before making second call
    await new Promise(resolve => setTimeout(resolve, 100)); // Small delay between calls

    // Second API call - Logout
    const logoutPayload = {
      sessionEnd: Date.now(),
      action: "logout",
      deviceId: sessionData?.deviceId || "web_app_id",
      userType: "admin",
      refreshToken: authUser.refreshToken,
      email: sessionData?.email || authUser.email,  // Use email from sessionData with fallback
      time: "5"
    };

    console.log('Sending logout payload:', logoutPayload);

    const logoutResponse = await fetch(`${config.api.API_URL}python/logout/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authUser.token
      },
      body: JSON.stringify(logoutPayload)
    });

    if (!logoutResponse.ok) {
      const logoutError = await logoutResponse.json();
      console.error('Logout failed:', logoutError);
    }

    // Clear all storage
    sessionStorage.removeItem("authUser");
    sessionStorage.removeItem("cognitoToken");
    sessionStorage.removeItem("sessionData");

    dispatch(logoutUserSuccess(true));
  } catch (error) {
    console.error('Logout error:', error);
    dispatch(apiError(error.message));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
      //   response = postSocialLogin(data);
      // }
      
      const socialdata = await response;
    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history('/dashboard')
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) =>{
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};